import React from 'react';
import {Card, Avatar, CardHeader, CardContent, InputAdornment, IconButton, withStyles} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import {connect} from "react-redux";
import {actions} from "../../actions";
import {ROLES, withRoles} from "../Permissions";

const styles = theme => ({
    editField: {
        width:'100%',
        marginBottom:'5px'
    },
    iconButton: {
        padding:0
    },
    commentCard:{
        width:'100%'
    }
});

const formatDate = function(date){
    return moment(date).format('LL');
}

const getInitials = function(name){
    if(name){
        return name.split(" ").map(name=>name[0]).join('');
    }
}

class Comment extends React.Component{
    constructor(props){
        super(props);
        this.lastComment = React.createRef();
        this.state={
            comments:[],
            comment:'',
            editMode:false,
            editedComment:''
        }
    }

    handleFieldChange = e =>{
        this.setState({
            comment:e.target.value
        })
    }

    editCommentHandler=e=>{
        e.preventDefault();
        const updatedComment = this.state.comment;
        this.props.editComment(this.props.index, updatedComment);
        this.setState({
            editMode: false
        });
    }

    cancelEditHandler=e=>{
        this.setState({
            editMode:false
        })
    }

    handleEditAutoFocus = (event) => {
        const lengthOfInput = event.target.value.length;
        return event.target.setSelectionRange(lengthOfInput, lengthOfInput);
    };

    deleteCommentHandler=()=>{
        this.props.deleteComment(this.props.index);
    }

    renderCommentRead(){
        return (
            <div ref = {this.lastComment}>
                {this.props.details.comment}
            </div>
        )
    }

    renderCommentEdit=()=>{
        return (
            <div className="form-group">
                <TextField
                    id="filled-multiline-flexible"
                    label="Edit Comment"
                    multiline
                    rowsMax={4}
                    value={this.state.comment}
                    onChange={this.handleFieldChange}
                    className={this.props.classes.editField}
                    onFocus={this.handleEditAutoFocus}
                    InputProps={{
                        autoFocus:true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton  className = {this.props.classes.iconButton} aria-label="Edit" onClick={this.enterEditMode}>
                                    <CheckIcon  onClick={this.editCommentHandler}/>
                                </IconButton>
                                <IconButton className = {this.props.classes.iconButton} aria-label="Edit" onClick={this.enterEditMode}>
                                    <CloseIcon onClick={this.cancelEditHandler}/>
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </div>
        )
    }

    renderIcons(){
        //logic for these buttons to only show for comment owner
        if(this.props.user.unid == this.props.details.unid){
            return(
                <span>
                <IconButton  className = {this.props.classes.iconButton} aria-label="Edit" onClick={this.enterEditMode}>
                    <EditIcon size = 'small'/>
                </IconButton>
                <IconButton  className = {this.props.classes.iconButton} aria-label="Delete" key={'12345'} onClick={this.deleteCommentHandler}>
                    <DeleteIcon/>
                </IconButton>
            </span>
            )
        }
    }

    enterEditMode=()=>{
        if(!this.state.editMode){
            this.setState({
                editMode:true,
                comment:this.props.details.comment
            })
        }
    }

    render(){
        return(
            <Card className={this.props.classes.commentCard} elevation = {4}>
                <CardHeader
                    avatar={
                        <Avatar>
                            {getInitials(this.props.details.author)}
                        </Avatar>
                    }
                    action={
                        this.renderIcons()
                    }
                    title = {this.props.details.author}
                    subheader={`Posted on ${formatDate(this.props.details.updatedDate)}`}
                    />
                    <CardContent>
                        { this.state.editMode ? this.renderCommentEdit() : this.renderCommentRead() }
                    </CardContent>
            </Card>

        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN, ROLES.REVIEWER])(Comment)));
